<main style="height: 100vh; overflow: hidden;" *ngIf="!loading">
  <router-outlet></router-outlet>
</main>

<!-- <p-dialog [visible]="!versioning.upToDate()" (visibleChange)="versioning.update()"
  [style]="{width: '80dvw', height: '80vh'}" [blockScroll]="true">
  <idel-release-notes [notes]="releaseNotes"></idel-release-notes>
</p-dialog> -->

<p-toast [position]="'bottom-right'" [key]="'idelibe-toast'"></p-toast>